// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"9d79039df840e170","744":"3e1f9b36e5b4367c","931":"4230dec2a8528c13"}[chunkId] + ".css";
};